import axios from 'axios'

// Direct axios client for the admin actions added in spec A5/B4 (change email,
// impersonation). These endpoints are custom controllers, so they are called
// directly instead of through the OpenAPI client (same approach as authApi.js).
export const http = axios.create()

// e.g. https://api-admin.workhub.ai/api — paths below are relative to it.
const base = () => process.env.REACT_APP_CLIENT_ADMIN_ENTRYPOINT

// Same as Utils.getUserData; not imported so this module stays free of aliased UI imports.
const storedToken = () => JSON.parse(localStorage.getItem('userData'))?.accessToken

const headers = (token) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token || storedToken()}`
})

const post = (path, body, token) => http
  .post(`${base()}${path}`, body, { headers: headers(token) })
  .then((response) => response.data)

// POST /api/users/{uuid}/change-email  { email, companyUuid? }
export const postChangeEmail = (userUuid, body) => post(`/users/${userUuid}/change-email`, body)

// POST /api/impersonations  { targetUuid, reason }
export const postImpersonation = (body) => post('/impersonations', body)

// POST /api/impersonations/{uuid}/end — callable with the impersonation token itself
export const postEndImpersonation = (impersonationUuid, token) => (
  post(`/impersonations/${impersonationUuid}/end`, {}, token)
)
